import { WallpaperCategory } from '@wetransfer/transfer/component/TransferCustomizationProvider/types';
import { Wallpaper } from '@wetransfer/transfer/store/customWallpapers';

import { CustomWallpaper } from './types';

export const normalizeCustomWallpaper = (
  wallpaper: CustomWallpaper
): Wallpaper => {
  const category =
    wallpaper.wallpaperCategory === 'branded'
      ? WallpaperCategory.BRANDED
      : wallpaper.wallpaperCategory === 'curated'
      ? WallpaperCategory.CURATED
      : wallpaper.wallpaperCategory === 'custom'
      ? WallpaperCategory.CUSTOM
      : undefined;

  const fileName =
    wallpaper.originalFileName || wallpaper.originalAssetUrl.split('/').pop();

  return {
    category,
    localId: wallpaper.assetId,
    assetId: wallpaper.assetId,
    srcSmall: wallpaper.wallpaperSmallUrl,
    srcMedium: wallpaper.wallpaperMediumUrl,
    srcLarge: wallpaper.wallpaperLargeUrl,
    extension: wallpaper.fileExtension,
    fileName,
  };
};
